// Phase 8 Plan 03 Task 1 — per-template walker for the `size-and-yield` template.
//
// Pure TS — no React, no DOM. Server-friendly: Phase 10 AI prompt-gen + Phase 13 SSR
// re-import from here. Hand-written per RESEARCH §"Pattern 2 Option A".
//
// configSchema source mirrored verbatim (../../schemas/widget-templates/size-and-yield.ts):
//   steps: ReadonlyArray<SizeAndYieldStep>  — each step: { id, label, multiplier, min?, max? }
//   yieldDisplay: { perStepFormula: string; unitsField: string; baseValue: number }
//   defaultStepId?: string
//
// Walker output: kind:'group' root with three children — steps array (nested group
// per step with id/label/multiplier leaves + optional min/max), yieldDisplay group,
// defaultStepId leaf.

import type { FieldDescriptor } from "../descriptors.js";

export function walkSizeAndYieldConfig(configPath: string): FieldDescriptor {
  return {
    kind: "group",
    name: "config",
    path: configPath,
    children: [
      {
        kind: "array",
        name: "steps",
        path: `${configPath}.steps`,
        itemDescriptor: {
          kind: "group",
          name: "step",
          path: `${configPath}.steps.*`,
          children: [
            {
              kind: "leaf",
              name: "id",
              path: `${configPath}.steps.*.id`,
              type: "string",
              required: true,
            },
            {
              kind: "leaf",
              name: "label",
              path: `${configPath}.steps.*.label`,
              type: "string",
              required: true,
            },
            {
              kind: "leaf",
              name: "multiplier",
              path: `${configPath}.steps.*.multiplier`,
              type: "number",
              required: true,
            },
            {
              kind: "leaf",
              name: "min",
              path: `${configPath}.steps.*.min`,
              type: "number",
              required: false,
            },
            {
              kind: "leaf",
              name: "max",
              path: `${configPath}.steps.*.max`,
              type: "number",
              required: false,
            },
          ],
        },
      },
      {
        kind: "group",
        name: "yieldDisplay",
        path: `${configPath}.yieldDisplay`,
        children: [
          {
            kind: "leaf",
            name: "perStepFormula",
            path: `${configPath}.yieldDisplay.perStepFormula`,
            type: "string",
            required: true,
          },
          {
            kind: "leaf",
            name: "unitsField",
            path: `${configPath}.yieldDisplay.unitsField`,
            type: "string",
            required: true,
          },
          {
            kind: "leaf",
            name: "baseValue",
            path: `${configPath}.yieldDisplay.baseValue`,
            type: "number",
            required: true,
          },
        ],
      },
      {
        kind: "leaf",
        name: "defaultStepId",
        path: `${configPath}.defaultStepId`,
        type: "string",
        required: false,
      },
    ],
  };
}
